
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/unsubscribe",
      function () {
        return require("private-next-pages/mobiworkx/unsubscribe.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/unsubscribe"])
      });
    }
  